export default __webpack_public_path__ + "static/media/next.3abb121f.webp";